// 用户协议
import React from "react";
import "./index.scss";

const RegisterRule = () => {
  return (
    <div className="rule-main">
      <div class="WordSection1">
        <h3>
          <span>User Agreement</span>
        </h3>
        <p class="MsoNormal">
          <b>
            <span lang="EN-US">1. Special reminder</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            This User Service Agreement is a legally binding contract between
            you and NovaAir Industrial Gases Sdn Bhd (hereinafter referred to as
            "NovaAir" or "we") for your registration and use of this APP. You
            need to read this Agreement carefully before using this APP. You
            agree and confirm that you have fully read, understood and accepted
            all the contents of this Agreement before you register as a member
            or use or accept the services we provide. Whenever you use this APP,
            it means that you have agreed to be bound by this Agreement.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You hereby agree and confirm that we have the right to modify and
            update this Agreement from time to time as needed and to publicize
            it on this APP by announcement.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you shall continue to use this service or this APP after the
            announcement of changes to the content of this Agreement, it means
            that you have fully read and understood the modified content of the
            Agreement, and you are deemed to have accepted the new user service
            agreement; if you do not agree to the modified content of the
            Agreement, you should immediately stop using this service or this
            APP.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">2. Registration</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You understand and acknowledge that this APP is only for individual
            user registration; user registration is free.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you register as an individual user through this APP, you should
            be a natural person with full civil rights and civil conduct
            capacity as required by law and who can independently bear civil
            liability. If you do not have the aforementioned subject
            qualifications, you should immediately stop registering or using the
            service, and all consequences resulting from this shall be solely
            borne by you and your guardian.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you apply to register as a member through this APP, you need to
            provide your name, contact information, and email address.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            If you register for the benefit of your company, please ensure that
            you have been properly authorized by the company and have the right
            to act on its behalf. If you refuse to provide this information, it
            will affect your use of the relevant functions of NovaAir products
            and services. You can cancel your account at your own will. Your
            cancellation of your account is irreversible. Once you cancel your
            account, we will no longer collect your personal information, and we
            will immediately delete all information about your account or make
            it anonymous.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">3. Account Management</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When you complete the member registration process or actually use
            the service in other permitted ways, you will be provided with an
            account with a unique ID number (hereinafter also referred to as the
            "account"). You can set a password for your account and log in to
            the APP with the username and password. You should keep your
            username and password properly, and you will be solely responsible
            for any losses caused by password leakage. You promise not to
            disclose your username and password to anyone else. If you find that
            anyone has impersonated or stolen your username and password or
            there are any other circumstances that may endanger the security of
            your account, you should immediately notify in an effective manner
            and request to suspend the relevant services. You understand that it
            takes us a reasonable time to act on your request and we are not
            responsible for the consequences that have occurred before taking
            action (including but not limited to any losses on your part).
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">IV. Service Usage Specifications</span>
          </b>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">
              1. This APP will provide the following different functions and
              services:
            </span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Order: After account authentication, you can place an order online
            through the mall. Customers can select the contract products and
            delivery date to complete the online order. During the order
            process, you need to provide the customer's delivery contact
            information; View historical orders: You can view all historical
            orders based on the delivery address and date range;
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">(II) User Guidelines</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            When using this APP service, users should abide by the relevant laws
            and regulations of the country, and the provisions of this
            Agreement, and any illegal or irregular behavior is prohibited, such
            as:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Any interference or damage to the APP or the servers and networks
            connected to it, or any other activities that interfere with or
            damage the service, or use the APP for any illegal purpose;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Publish and disseminate information containing the following
            contents through this APP:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) Derogatory remarks about religion, race or gender, etc.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) Speech that infringes upon the interests of the Party and the
            state; information or advertising information that harasses, abuses
            or threatens other users;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (3) Information that infringes upon any third party’s copyright,
            patent, trademark, trade secret or other proprietary rights or
            reputation rights;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (4) Any other information that violates relevant national laws and
            regulations.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">V. Statement of Responsibility</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            During the use of this APP, if you violate this Agreement or other
            relevant laws and regulations, we have the right to deal with it
            accordingly (including but not limited to suspending or terminating
            the provision of services to you). If this causes us losses or a
            third party files a lawsuit or claim against us or we are punished
            by any administrative department, you shall compensate us for the
            losses and (or) expenses incurred, including compensation, fines,
            loss of reputation, litigation fees, attorney fees, etc.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You shall bear all legal liability for any damage caused to any
            third party due to your suspected violation of this Agreement, and
            shall indemnify us from any loss or increased expenses thereby.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Any advice or information (whether written or oral) obtained by you
            from this APP service does not constitute any guarantee or warranty
            other than those expressly provided in these User Service Terms,
            except where national laws and regulations prohibit the exclusion of
            some guarantees or warranties.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            In view of the particularity of the Internet, we are not responsible
            for any losses caused to users due to hacker attacks, Internet
            connectivity interruptions or system failures.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">VI. Intellectual Property Statement</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            Yingde is the intellectual property rights holder of this APP. All
            copyrights, trademarks, patents, trade secrets and other
            intellectual property rights of this APP, as well as all information
            content related to this APP (including but not limited to text,
            pictures, audio, video, interface design, relevant data or
            electronic documents, etc.) are protected by the laws and
            regulations of the People's Republic of China and relevant
            international treaties. Yingde enjoys the above intellectual
            property rights, except for the rights that relevant rights holders
            should enjoy in accordance with the law.
          </span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">VII. Termination of Agreement</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            You agree that in the following circumstances, we have the right to
            suspend or terminate the provision of part or all of our services to
            you with or without notice, temporarily freeze or permanently freeze
            (cancel) your account, without any liability to you or any third
            party, and we reserve the right to pursue your legal liability:
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (1) The information or materials you provide are untrue,
            inaccurate, or incomplete;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (2) You implement or plan to destroy or attack the integrity of
            this APP or the network;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (3) You use or provide any computer or mobile virus, disguised
            destructive program, computer worm, time bomb or other destructive
            program that destroys, interferes with, intercepts or invades any
            system, data or personal information;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (4) You steal the username or password of others on this APP;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (5) You allow others to use the service without written consent;
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            • (6) Any other illegal, disciplinary or breach of contract occurs.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">&nbsp;</span>
        </p>

        <p class="MsoNormal">
          <b>
            <span lang="EN-US">8. Dispute Resolution</span>
          </b>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">
            This Agreement shall be governed by the laws of Malaysia. If any
            dispute arises between the two parties, it shall be resolved through
            friendly negotiation first. If the negotiation fails, the dispute
            may be submitted to arbitration in Malaysia.
          </span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">&nbsp;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">&nbsp;</span>
        </p>

        <p class="MsoNormal">
          <span lang="EN-US">&nbsp;</span>
        </p>
      </div>
    </div>
  );
};

export default RegisterRule;
